module.exports = "<p>\n  pages works!\n</p>\n"